import { useEffect, useState } from 'react';

/**
 * Kakao SDK는 GlobalScript에서 로드 및 초기화됨
 * 이 훅은 SDK가 준비되었는지만 확인하고 공유 기능을 제공
 */
export const useKakaoShare = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // SDK 로드 완료 대기
    const checkKakaoReady = () => {
      if (window.Kakao?.isInitialized?.()) {
        setIsInitialized(true);
      } else {
        // SDK가 아직 로드되지 않았다면 잠시 후 다시 확인
        setTimeout(checkKakaoReady, 100);
      }
    };

    checkKakaoReady();
  }, []);

  const shareToKakao = (
    shareUrl: string,
    title: string,
    description: string,
    imageUrl: string,
    buttonTitle = '자세히 보기',
  ) => {
    if (!isInitialized) {
      console.error('Kakao SDK가 초기화되지 않았습니다.');

      return;
    }

    window.Kakao?.Share?.sendDefault?.({
      objectType: 'feed',
      content: {
        title: title,
        description: description,
        imageUrl: imageUrl,
        link: {
          mobileWebUrl: shareUrl,
          webUrl: shareUrl,
        },
      },
      buttons: [
        {
          title: buttonTitle,
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl,
          },
        },
      ],
    });
  };

  return { shareToKakao, isInitialized };
};
